import { FLAGS, useFeatureFlag } from 'components/ff4j'

const useProductImage = (product) => {
    const segregecaoEnabled = useFeatureFlag(FLAGS.SEGREGACAO_CNPJ)

    if ((product.id === 700 || product.type === 'POD') && segregecaoEnabled)
        return product.tiffanyImage
    return product.image
}

export default useProductImage
